const ICONS_GUIDE_LIST = ['Home', 'Search', 'Settings', 'Trash']

export default ICONS_GUIDE_LIST
